import React from 'react';
import SVG from 'react-inlinesvg';
import classnames from 'classnames';
import { IconNames, IconType } from '../../icons';

import styles from './icon.module.scss';

export type IconProps = {
  name: IconType;
  title?: string;
} & Pick<JSX.IntrinsicElements['svg'], 'className' | 'aria-label' | 'role' | 'aria-hidden'>;

const baseClass = 'icon';

export const Icon: React.FC<IconProps> = ({
  className,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = 'true',
  name,
  role,
  title
}) => {
  const size = name.endsWith('--small') ? 'small' : 'medium';
  const classes = classnames(styles[`${baseClass}--${size}`], className);

  return (
    <SVG
      className={classes}
      role={role}
      title={title}
      aria-hidden={ariaHidden}
      data-testid="icon-component"
      aria-label={ariaLabel}
      src={IconNames[name]}
    />
  );
};
